import Skeleton from 'react-loading-skeleton';

import Container from '@/components/@base/container';

export default function Loading() {
  return (
    <Container className='my-5 w-full overflow-hidden rounded-md border border-[#E9EBF1] p-[15px] last:mb-0 md:p-6'>
      <Container className='flex items-center justify-between'>
        <Container className='mb-4 flex items-center gap-2'>
          <Skeleton circle width={30} height={30} />
          <Skeleton width={90} height={25} />
        </Container>
        <Container className='mb-4 flex items-center gap-2'>
          <Skeleton width={120} height={25} />
        </Container>
      </Container>
      <Skeleton containerClassName='w-full' count={2.5} />
      <Skeleton width={78} height={27} className='mt-2' />
    </Container>
  );
}
